import { questionnaireSectionApi } from '@/lib/api/questionnaireApi';
import {
  QuestionnaireSectionDetailProps,
  QuestionnaireTemplateDetailProps,
} from '@/types/questionnaire';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export default function useQuestionnaireSection({
  template,
}: {
  template: QuestionnaireTemplateDetailProps & { current_section_id: number };
}) {
  const [currentSectionId, setCurrentSectionId] = useState<number | null>(
    template.current_section_id
  );

  const {
    data: sectionDetails,
    isLoading,
    error,
  } = useQuery<QuestionnaireSectionDetailProps>({
    queryKey: ['section', currentSectionId],
    queryFn: () => questionnaireSectionApi.getById(currentSectionId!),
    enabled: currentSectionId !== null,
  });
  return {
    currentSectionId,
    setCurrentSectionId,
    sectionDetails,
    isSectionDetailLoading: isLoading,
    error,
  };
}
